import type { PlayingLevelValues } from 'utils/shared/playerFinder';
import { SportsRatingsField } from 'components/PlayerFinder';
import ProfileFormModal from './ProfileFormModal';
import type { ProfileEditorModalProps } from './types';
import { useModalDraft } from './useModalDraft';

interface Props extends ProfileEditorModalProps {
  defaultValues: PlayingLevelValues | null;
  onSave: (values: PlayingLevelValues) => Promise<boolean>;
}

export default function PlayingLevelFormModal({
  isOpen,
  onClose,
  defaultValues,
  onSave,
  isSaving,
  error,
}: Props) {
  const { values, setValues, handleSave } = useModalDraft(isOpen, defaultValues, onSave, onClose);

  return (
    <ProfileFormModal
      isOpen={isOpen}
      onClose={onClose}
      title="My experience"
      description="Choose your sport(s) and skill level. You can select more than one."
      onSave={handleSave}
      isSaving={isSaving}
      error={error}
    >
      {values && <SportsRatingsField value={values} onChange={setValues} />}
    </ProfileFormModal>
  );
}
